<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left">
            <h3>{{ $t('force.activate.title') }}</h3>
        </div>

        <div class="mt-4" v-if="(! isLoaded)">
            {{ $t('loading') }}
        </div>

        <form class="mt-4" v-if="isLoaded" onsubmit="return false;">
            <div class="form-group">
                <label class="as-block">{{ $t('force.activate.aubeIdLabel') }}:</label>
                <label class="as-block">{{ aubeId }}</label>
            </div>
            <div class="form-group">
                <label class="as-block" for="forceClubSerial">{{ $t('force.activate.serialNumberLabel') }}:</label>
                <label class="as-block" v-if="(serialNumber)">{{ serialNumber }}</label>

                <div v-if="(! serialNumber)">
                    <input id="forceClubSerial" name="forceClubSerial" v-model="formData.forceClubSerial"
                        type="text" class="form-control" v-bind:class="{ 'is-invalid': errors.forceClubSerial }" />
                    <div v-if="errors.forceClubSerial" class="invalid-feedback show">
                        {{ $t('errors.' + errors.forceClubSerial) }}
                    </div>
                </div>
            </div>

            <div class="text-center" v-if="(! serialNumber)">
                <div class="pb-4">
                    <button type="button" v-on:click="nextButtonHandler()" :disabled="nextBtnDisabled()" class="btn btn-primary force-club-activate-module-button-label">
                        {{ $t('force.activate.nextBtn') }}
                    </button>
                </div>
            </div>
        </form>

        <!-- Modal View -->
        <vodal :show="show" :width="310" :height="200" :closeButton="false" animation="slideDown" @hide="show = false">
            <div class="flex">
                <div class="container">
                    <div>
                        <p class="text-center m-0 p-0">
                            {{ $t('force.activate.question[0]') }}
                        </p>
                        <p class="text-center m-0 p-0 mt-1 serial">
                            {{ formData.forceClubSerial }}
                        </p>
                        <p class="text-center m-0 p-0 mt-1">
                            {{ $t('force.activate.question[1]') }}
                        </p>
                    </div>
                </div>
                <div class="text-center buttons">
                    <button type="button" class="btn btn-outline-primary mr-2 force-club-activate-module-button-label" @click="cancelButtonHandler()">
                        {{ $t('force.activate.cancelButton') }}
                    </button>
                    <button type="button" class="btn btn-primary ml-2 force-club-activate-module-button-label" @click="submitButtonHandler()">
                        {{ $t('force.activate.registButton') }}
                    </button>
                </div>
            </div>
        </vodal>
    </div>
</template>

<script>
    import userService from '../services/UserService';

    export default {
        name: 'activation',

        data() {
            return {
                formData: this.getDefaultFields(),
                errors: this.getDefaultFields(),

                aubeId: '',
                serialNumber: '',
                submitted: false,
                isValid: false,
                isLoaded: false,
                show: false,
            }
        },

        async created() {
            let d = (await userService.getUserFrontendData()).data;

            if (this.$route.params.formData) {
                this.formData = this.$route.params.formData;

                if (d.forceClub) {
                    this.formData.forceClubId = d.forceClub.force_club_id;
                } else {
                    this.formData.forceClubId = d.external_user_id;
                }
            } else {
                if (d.forceClub) {
                    this.formData.forceClubId = d.forceClub.force_club_id;
                    this.formData.forceClubSerial = d.forceClub.force_club_serial;
                    this.serialNumber = this.formData.forceClubSerial;
                } else {
                    this.formData.forceClubId = d.external_user_id;
                }
            }

            this.aubeId = d.email;
            this.isLoaded = true;
        },

        watch: {
            'formData.forceClubSerial': function(value, old) {
                this.formData.forceClubSerial = value;
                this.validate();
            }
        },

        methods: {
            validate() {
                if (this.formData.forceClubSerial.search(new RegExp('^[a-zA-Z0-9]+$')) !== -1) {
                    this.errors.forceClubSerial = null;
                    this.isValid = true;
                } else {
                    this.errors.forceClubSerial = 'FORCE_CLUB_SERIAL_IS_NOT_VALID';
                    this.isValid = false;
                }

            },

            getDefaultFields() {
                return {
                    forceClubId: '',
                    forceClubSerial: '',
                }
            },

            nextBtnDisabled() {
                return this.submitted || (! this.isValid);
            },

            cancelButtonHandler() {
                this.show = false;
            },

            async nextButtonHandler() {
                window.document.activeElement.blur();

                let r = await userService.forceClubIsActivated(this.formData.forceClubSerial);
                if (r.data.is_activated) {
                    this.errors.forceClubSerial = 'FORCE_CLUB_SERIAL_IS_ACTIVATED';
                    this.isValid = false;
                } else {
                    this.errors.forceClubSerial = null;
                    this.isValid = true;
                }

                if (this.errors.forceClubSerial !== null) {
                    return;
                }

                this.show = true;
            },

            submitButtonHandler() {
                this.activate();
            },

            async activate() {
                this.errors = this.getDefaultFields();
                this.submitted = true;

                try {
                    await userService.forceClubActivate(this.formData);
                    this.$router.push({ name: 'forceTabActivateSuccess' })
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                    this.show = false;
                }
            },
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .as-block {
        display: block;
    }
    .show {
        display: block !important;
    }
    .flex {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .container {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
    }
    .serial {
        font-size: 1.5em;
        font-weight: bold;
    }
    .force-club-activate-module-button-label {
        white-space: nowrap;
    }
</style>
